<div class="sticky-top top-0">
  <portal-critical-alert-banner></portal-critical-alert-banner>
  <m-top-nav
    [logo]="logo()"
    [brandPicker]="brandPicker()"
    [primaryActions]="primaryActions()"
    [secondaryActions]="secondaryActions()"
    [trailingAction]="trailingAction()"
    [avatar]="avatar()"
    (actionClicked)="onActionClicked($event)"
    (brandSelected)="onBrandSelected($event)"
    (brandPickerOpened)="onBrandPickerOpened()"></m-top-nav>
</div>

<m-modal
  [visible]="logOutModalIsVisible()"
  (visibleChange)="logOutModalIsVisible.set($event)"
  [closable]="false"
  [modal]="true"
  [showFooter]="false">
  <ng-container modalHeader>
    <h4 class="h4 mb-0 text-gray-1000">Logging Out</h4>
  </ng-container>
  <p class="b1 p-4">Thank you for using Measured Portal!</p>
</m-modal>

<portal-notification-center
  [visibilityType]="notificationViewMode.popup"
  [notificationCenterVisible]="notificationCenterVisible()"
  (closePopup)="onNotificationCenterClosed()"></portal-notification-center>

<portal-feedback-modal
  #feedbackModal
  (submitFeedback)="onFeedbackSubmit($event)">
</portal-feedback-modal>
